import { Card } from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import EndPoints from 'shared/endPoints/EndPoints.json';
import useExcelUpload from 'shared/hooks/excel-upload-hook';
import UploadModal from '../UploadContract/UploadModal';
import UploadResults from '../UploadContract/UploadResults';

export default function UploadDevicesForReset() {
  const { fileList, successList, errorList, hasResults, handleChange } =
    useExcelUpload({
      successKey: 'succeededDevices',
      errorKey: 'failedDevices',
      formatError: device => (
        <>
          <b>{device.imei}</b> - {device.reason}
        </>
      )
    });

  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Μεταφόρτωση Αρχείου Συσκευών προς Μηδενισμό"
      style={{ textAlign: 'center' }}
    >
      <UploadModal
        action={EndPoints.PACKING.RESETFROMEXCEL}
        method="put"
        onChange={handleChange}
        fileList={fileList}
        style={{ marginBottom: 20 }}
      />

      {hasResults && (
        <UploadResults
          title="Αποτελέσματα"
          successList={successList}
          errorList={errorList}
          successTitle="Επιτυχημένες Συσκευές"
          errorTitle="Αποτυχημένες Συσκευές"
        />
      )}
    </Card>
  );
}
